<!-- 最小流量配置 -->
<template>
  <a-row :gutter="24">
    <a-col :md="24" :sm="24">
<!--      <a-card title="更新参考值" style="margin-bottom: 10px">-->
<!--        <a-form-model ref="form" :model="model" :rules="validatorRules" layout="inline">-->
<!--          <a-form-model-item label="是否更新">-->
<!--            <a-checkbox :value="model.minFlow"></a-checkbox>-->
<!--          </a-form-model-item>-->
<!--        </a-form-model>-->
<!--      </a-card>-->
      <a-card :title="$t('夜间时段选择')" style="margin-bottom: 10px">
        <a-button type="primary" slot="extra" @click="saveNightTimeConfig" :loading="saveLoading">{{ $t('保存') }}</a-button>
        <a-form-model ref="nightTimeForm" :model="nightTimeModel" layout="inline">
          <a-form-model-item :label="$t('夜间时段')">
            <el-time-picker
              is-range
              size="small"
              value-format="HH:mm"
              format="HH:mm"
              v-model="nightTimeModel.timeRange"
              range-separator="-"
              :start-placeholder="$t('开始时间')"
              :end-placeholder="$t('结束时间')"
              :placeholder="$t('选择时间范围')"
            >
            </el-time-picker>
          </a-form-model-item>
          <a-form-model-item :label="$t('连续异常天数')">
            <a-input-number
              v-model="nightTimeModel.continuousDays"
              :min="0"
              :max="31"
              style="width: 100%"
            ></a-input-number>
          </a-form-model-item>
        </a-form-model>
      </a-card>
      <a-card :title="$t('合法用水系数设定')" style="margin-bottom: 10px">
        <a-button type="primary" slot="extra" @click="handleAdd(1)">{{ $t('新增') }}</a-button>
        <!-- <a-radio-group v-model="model.radioValue">
          <a-radio value="1">分区通用设置</a-radio>
          <a-radio value="2">分区独立设置</a-radio>
        </a-radio-group> -->
        <a-table :columns="columns1" :data-source="dataSource1" :pagination="false">
          <template slot="action" slot-scope="text, record">
            <a @click="handleEdit(record, 1)">{{ $t('编辑') }}</a>
            <a-divider type="vertical"></a-divider>
            <a @click="handleDelete(record, 1)">{{ $t('删除') }}</a>
          </template>
        </a-table>
      </a-card>
      <a-card :title="$t('最小流量异常设定')" style="margin-bottom: 10px">
        <a-button type="primary" slot="extra" @click="handleAdd(2)">{{ $t('新增') }}</a-button>
        <a-table :columns="columns2" :data-source="dataSource2" :pagination="false">
          <template slot="alertColor" slot-scope="text, record">
            <el-color-picker v-model="record.alertColor" size="mini"></el-color-picker>
          </template>
          <template slot="action" slot-scope="text, record">
            <a @click="handleEdit(record, 2)">{{ $t('编辑') }}</a>
            <a-divider type="vertical"></a-divider>
            <a @click="handleDelete(record, 2)">{{ $t('删除') }}</a>
          </template>
        </a-table>
      </a-card>
      <a-card :title="$t('建议意见设定')">
        <a-button type="primary" slot="extra" @click="handleAdd(3)">{{ $t('新增') }}</a-button>
        <a-table :columns="columns3" :data-source="dataSource3" :pagination="false">
          <template slot="color" slot-scope="text, record">
            <el-color-picker v-model="record.color" size="mini"></el-color-picker>
          </template>
          <template slot="action" slot-scope="text, record">
            <a @click="handleEdit(record, 3)">{{ $t('编辑') }}</a>
            <a-divider type="vertical"></a-divider>
            <a @click="handleDelete(record, 3)">{{ $t('删除') }}</a>
          </template>
        </a-table>
      </a-card>
      <Model1 ref="model1" @ok="callback" />
      <Model2 ref="model2" @ok="callback" />
      <Model3 ref="model3" @ok="callback" />
    </a-col>
  </a-row>
</template>
            
    <script>
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getAction } from '@/api/manage'
import { editDictItem } from '@/api/api'
import JInput from '@/components/jeecg/JInput'
import { AreaChoosetMixin } from '@/mixins/AreaChooseMixin'
import Model1 from './modules/model1.vue'
import Model2 from './modules/model2.vue'
import Model3 from './modules/model3.vue'

export default {
  name: 'WaterSupplyAnalysis',
  mixins: [JeecgListMixin, AreaChoosetMixin, mixinDevice],
  components: {
    JInput,
    Model1,
    Model2,
    Model3,
  },
  data() {
    return {
      description: '供水量分析',
      collapsed: false,
      dataSource1: [
        {
          id: 1,
          userType: '民用',
          legalUseCoefficient: '12',
          settingType: 0
        },
        {
          id: 2,
          userType: '商用',
          legalUseCoefficient: '11',
          settingType: 0
        },
        {
          id: 3,
          userType: '机关团体',
          legalUseCoefficient: '5',
          settingType: 0
        },
      ],
      dataSource2: [
        {
          id:1,
          minFlow: 10,
          maxFlow: 40,
          symbol: '>=',
          changeAmplitude: 50,
          alertColor: '#EBC20C'
        },
        {
          id:2,
          minFlow: 20,
          maxFlow: 50,
          symbol: '>=',
          changeAmplitude: 40,
          alertColor: '#E72012'
        },
        {
          id:3,
          minFlow: 10,
          maxFlow: 40,
          symbol: '>=',
          changeAmplitude: 50,
          alertColor: '#AFE10A'
        },
      ],
      dataSource3: [
        {
          id: 1,
          exception: '异常',
          klValue: '10',
          range: '10-20',
          suggestion: '建议1',
          color: '#E72012',
        },
        {
          id: 2,
          exception: '连接异常',
          klValue: '10',
          range: '10-20',
          suggestion: '建议2',
          color: '#E72012',
        },
        {
          id: 3,
          exception: '连接异常',
          klValue: '10',
          range: '10-20',
          suggestion: '建议3',
          color: '#E72012',
        },
      ],
      url: {
        list: '/jeecg-engineering/inspection/inspectionUser/list',
        delete: '/jeecg-engineering/inspection/inspectionUser/delete',
        deleteBatch: '/jeecg-engineering/inspection/inspectionUser/deleteBatch',
        exportXlsUrl: '/jeecg-engineering/ticket/tickets/exportXls',
        importExcelUrl: 'jeecg-engineering/ticket/tickets/importExcel',
      },
      date: [],
      model: {},
      validatorRules: {},
      // 夜间时段配置
      nightTimeModel: {
        timeRange: [],
        continuousDays: 2
      },
      saveLoading: false,
      dictCode: 'mnf_time_config',
      dictItems: [],
      dictId: '',
    }
  },
  created() {
    this.loadNightTimeConfig()
  },
  computed: {
    // i18n：表头使用 computed 以响应语言切换
    columns1() {
      return [
        {
          title: this.$t('序号'),
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: (t, r, index) => {
            return parseInt(index) + 1
          },
        },
        {
          title: this.$t('居民类型'),
          align: 'center',
          dataIndex: 'userType',
          customRender: (t) => this.$t(t),
        },
        {
          title: this.$t('合法用水系数'),
          align: 'center',
          dataIndex: 'legalUseCoefficient',
        },
        {
          title: this.$t('设置类型'),
          align: 'center',
          dataIndex: 'settingType',
          customRender: (t, r, index) => {
            if (t == 1) {
              return this.$t('分区通用设置')
            } else {
              return this.$t('分区独立设置')
            }
          },
        },
        {
          title: this.$t('操作'),
          align: 'center',
          dataIndex: 'action',
          width: 147,
          scopedSlots: { customRender: 'action' },
        },
      ]
    },
    columns2() {
      return [
        {
          title: this.$t('序号'),
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: (t, r, index) => {
            return parseInt(index) + 1
          },
        },
        {
          title: this.$t('流量区间最小值'),
          align: 'center',
          dataIndex: 'minFlow',
        },
        {
          title: this.$t('流量区间最大值'),
          align: 'center',
          dataIndex: 'maxFlow',
        },
        {
          title: this.$t('数字符号'),
          align: 'center',
          dataIndex: 'symbol',
        },
        {
          title: this.$t('变化幅度(%)'),
          align: 'center',
          dataIndex: 'changeAmplitude',
        },
        {
          title: this.$t('报警颜色'),
          align: 'center',
          dataIndex: 'alertColor',
          scopedSlots: { customRender: 'alertColor' },
        },
        {
          title: this.$t('操作'),
          align: 'center',
          dataIndex: 'action',
          width: 147,
          scopedSlots: { customRender: 'action' },
        },
      ]
    },
    columns3() {
      return [
        {
          title: this.$t('序号'),
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: (t, r, index) => {
            return parseInt(index) + 1
          },
        },
        {
          title: this.$t('异常/连接异常'),
          align: 'center',
          dataIndex: 'exception',
          customRender: (t) => this.$t(t),
        },
        {
          title: this.$t('KL值'),
          align: 'center',
          dataIndex: 'klValue',
        },
        {
          title: this.$t('区间'),
          align: 'center',
          dataIndex: 'range',
        },
        {
          title: this.$t('建议意见'),
          align: 'center',
          dataIndex: 'suggestion',
          customRender: (t) => this.$t(t),
        },
        {
          title: this.$t('颜色'),
          align: 'center',
          dataIndex: 'color',
          scopedSlots: { customRender: 'color' }
        },
        {
          title: this.$t('操作'),
          align: 'center',
          dataIndex: 'action',
          width: 147,
          scopedSlots: { customRender: 'action' },
        },
      ]
    },
  },
  methods: {
    // 加载夜间时段配置
    loadNightTimeConfig() {
      // 第一步：通过 dictCode 获取字典 ID
      getAction('/sys/dict/list', { dictCode: this.dictCode }).then(dictRes => {
        if (!dictRes.success || !dictRes.result || !dictRes.result.records || dictRes.result.records.length === 0) {
          console.warn('未找到字典配置:', this.dictCode)
          // 使用默认值
          this.nightTimeModel.timeRange = ['20:00', '04:00']
          this.nightTimeModel.continuousDays = 2
          return
        }

        const dictId = dictRes.result.records[0].id

        // 第二步：通过 dictId 获取字典项
        getAction('/sys/dictItem/list', { dictId: dictId }).then(itemRes => {
          if (itemRes.success && itemRes.result && itemRes.result.records) {
            const items = itemRes.result.records

            // 从字典项中提取配置值
            // itemText: 键值 (start_time, end_time, continue_day)
            // itemValue: 实际值 (02:00, 04:00, 2)
            items.forEach(item => {
              switch (item.itemText) {
                case 'start_time':
                  this.$set(this.nightTimeModel.timeRange, 0, item.itemValue)
                  break
                case 'end_time':
                  this.$set(this.nightTimeModel.timeRange, 1, item.itemValue)
                  break
                case 'continue_day':
                  this.nightTimeModel.continuousDays = parseInt(item.itemValue) || 2
                  break
              }
            })

            // 确保时间范围是有效的数组
            if (!this.nightTimeModel.timeRange || this.nightTimeModel.timeRange.length === 0) {
              this.nightTimeModel.timeRange = ['20:00', '04:00']
            }

            // 保存字典ID供后续更新使用
            this.dictId = dictId
            this.dictItems = items
          } else {
            // 如果没有配置，使用默认值
            this.nightTimeModel.timeRange = ['20:00', '04:00']
            this.nightTimeModel.continuousDays = 2
          }
        }).catch(() => {
          // 获取字典项失败时使用默认值
          this.nightTimeModel.timeRange = ['20:00', '04:00']
          this.nightTimeModel.continuousDays = 2
        })
      }).catch(() => {
        // 获取字典失败时使用默认值
        this.nightTimeModel.timeRange = ['20:00', '04:00']
        this.nightTimeModel.continuousDays = 2
      })
    },

    // 保存夜间时段配置
    saveNightTimeConfig() {
      if (!this.nightTimeModel.timeRange || this.nightTimeModel.timeRange.length !== 2) {
        this.$message.warning(this.$t('请选择完整的时间范围'))
        return
      }

      this.saveLoading = true

      // 准备更新的数据映射 (itemText -> itemValue)
      const configMap = {
        'start_time': this.nightTimeModel.timeRange[0], // 开始时间
        'end_time': this.nightTimeModel.timeRange[1],   // 结束时间
        'continue_day': this.nightTimeModel.continuousDays.toString() // 连续天数
      }

      // 重新获取最新的字典项列表
      getAction('/sys/dictItem/list', { dictId: this.dictId }).then(itemRes => {
        if (!itemRes.success || !itemRes.result || !itemRes.result.records) {
          this.$message.error(this.$t('获取字典项失败'))
          this.saveLoading = false
          return
        }

        const existingItems = itemRes.result.records
        const updatePromises = []

        // 遍历需要更新的配置项
        Object.keys(configMap).forEach(itemText => {
          const existingItem = existingItems.find(item => item.itemText === itemText)

          if (existingItem) {
            // 更新现有项 - 字段映射：itemText是键值，itemValue是实际值
            updatePromises.push(
              editDictItem({
                id: existingItem.id,
                dictId: existingItem.dictId,
                itemText: itemText,              // 键值保持不变
                itemValue: configMap[itemText],   // 更新实际值
                status: 1,
                sortOrder: existingItem.sortOrder || 0
              })
            )
          } else {
            // 如果字典项不存在，提示用户
            console.warn(`字典项 ${itemText} 不存在`)
          }
        })

        if (updatePromises.length === 0) {
          this.$message.warning(this.$t('没有找到需要更新的字典项，请先在系统字典管理中创建相关字典项'))
          this.saveLoading = false
          return
        }

        Promise.all(updatePromises).then(results => {
          const allSuccess = results.every(r => r.success)
          if (allSuccess) {
            this.$message.success(this.$t('保存成功'))
            this.loadNightTimeConfig() // 重新加载配置
          } else {
            this.$message.error(this.$t('部分保存失败，请检查数据'))
          }
        }).catch(error => {
          console.error('保存失败:', error)
          this.$message.error(this.$t('保存失败'))
        }).finally(() => {
          this.saveLoading = false
        })
      }).catch(error => {
        console.error('获取字典项失败:', error)
        this.$message.error(this.$t('获取字典项失败'))
        this.saveLoading = false
      })
    },

    handleAdd(arg) {
      switch (arg) {
        case 1:
          this.$refs.model1.add()
          this.$refs.model1.title = this.$t('新增')
          this.$refs.model1.disableSubmit = false
          break
        case 2:
          this.$refs.model2.add()
          this.$refs.model2.title = this.$t('新增')
          this.$refs.model2.disableSubmit = false
          break
        case 3:
          this.$refs.model3.add()
          this.$refs.model3.title = this.$t('新增')
          this.$refs.model3.disableSubmit = false
          break
      }
    },
    handleEdit(record, arg) {
      switch (arg) {
        case 1:
          this.$refs.model1.edit(record)
          this.$refs.model1.title = this.$t('编辑')
          this.$refs.model1.disableSubmit = false
          break
        case 2:
          this.$refs.model2.edit(record)
          this.$refs.model2.title = this.$t('编辑')
          this.$refs.model2.disableSubmit = false
          break
        case 3:
          this.$refs.model3.edit(record)
          this.$refs.model3.title = this.$t('编辑')
          this.$refs.model3.disableSubmit = false
          break
      }
    },
    handleDelete(record, arg) {
      switch (arg) {
        case 1:
          
          break
        case 2:
          
          break
        case 3:

          break
      }
    },
    callback() {
      // 可以在这里添加回调逻辑
    },
  },
}
</script>
<style lang="less" scoped>
@import '~@assets/less/common.less';
::v-deep .ant-card-head{
  min-height: auto;
  padding: 0 10px;
  .ant-card-head-title{
    padding: 10px 0;
  }
}
::v-deep .ant-card-body{
  padding: 12px;
}
::v-deep .ant-card-head-title::before{
    content: '';
    display: inline-block;
    width: 3px;
    height: 12px;
    border-radius: 4px;
    background-color: #1890FF;
    margin-right: 5px;
}
</style>